<template>
  <b-container v-if="this.$root.token">
    <br/>
    <h3>Group Performance Coaching (GPC) Sessions</h3>
    <br/>
    <b-tabs v-model="tabIndex">
      <b-tab title="Search GPC Sessions">
        <g-p-c-search @edit-gpc="gpcToEdit = $event; tabIndex = 1;"/>
      </b-tab>
      <b-tab title="Enter GPC Session">
        <g-p-c-add :gpcSessionToEdit="gpcToEdit"/>
      </b-tab>
    </b-tabs>
  </b-container>

</template>
<script>
// @ is an alias to /src
import GPCAdd from "@/components/GPCAdd.vue";
import GPCSearch from "@/components/GPCSearch.vue";

export default {
  name: "GPCSessions",
  components: {
    GPCAdd,
    GPCSearch
  },
  data() {
    return {
      gpcToEdit: null,
      tabIndex: 0
    };
  }
}
</script>
<style>
.buttonbar {
  padding-top: 4em;
  padding-bottom: 4em;
}
</style>



// WEBPACK FOOTER //
// src/views/GPCSessions.vue